import React from 'react';
import * as styles from './Shortcut.module.scss';
import { IS_APPLE } from '../constants/os';

const KEY_MAP: Record<string, React.ReactNode> = {
  mod: IS_APPLE ? <span className={styles.appleCmd}>⌘</span> : 'Ctrl',
  option: IS_APPLE ? 'Opt' : 'Alt',
  shift: 'Shift',
  space: 'Space',
  enter: 'Enter',
};

interface ShortcutProps {
  input?: string;
  keys?: string;
}

const Shortcut = ({ input, keys }: ShortcutProps) => {
  const keyTokens = keys?.split(/(\+)/g);

  return (
    <div className={styles.shortcut}>
      {input && <code>{input}</code>}
      {keyTokens &&
        keyTokens.length > 0 &&
        keyTokens.map((token) =>
          token === '+' ? (
            '+'
          ) : (
            <kbd key={token}>{KEY_MAP[token] ?? token}</kbd>
          ),
        )}
    </div>
  );
};

export default Shortcut;
